import httpClient from '../../api/httpClient'
import _ from 'lodash'
import { fetchWrapper } from '../../utils/helper'
import { countries } from '../../utils/helper'

export default {
  namespaced: true,
  state: {
    loading: false,
    approvementLoading: false,
    recalculationLoading: false,
    isCreatingCreditInvoice: false,
    error: '',
    success: '',
    storeInvoicePayments: [],
    dates: [],
    filter: {
      date: '',
      country: 'ALL',
    },
    countries,
  },
  mutations: {
    update(state, { path, value }) {
      _.set(state, path, value)
    },
  },
  getters: {
    filter: (state) => state.filter,
    getAttribute: (state) => (path) => state[path],
  },
  actions: {
    getDates({ commit }) {
      fetchWrapper(async () => {
        const { data } = await httpClient.get('/store-invoice-payments/dates')
        const dates = data.map(function (date) {
          let label = date.payment_period
          if (date.locked) {
            label += ' (locked)'
          }

          return {
            label: label,
            value: date.payment_period,
            locked: date.locked,
          }
        })

        commit('update', { path: 'dates', value: dates })
        // Set first date onlocked date as the default date if date wasn't set
        const notLockedDates = dates.filter((obj) => !obj.locked)
        commit('update', { path: 'filter.date', value: notLockedDates[notLockedDates.length - 1].value })
      }, commit)
    },
    search({ commit, state }) {
      return fetchWrapper(async () => {
        const { data } = await httpClient.get('/store-invoice-payments/search', {
          params: {
            payment_period: state.filter.date,
            country: state.filter.country,
          },
        })
        commit('update', { path: 'storeInvoicePayments', value: data })
      }, commit)
    },
    changeApprovement({ commit, dispatch }, { id, isApproved }) {
      return fetchWrapper(
        async (id, isApproved) => {
          const { data } = await httpClient.put('/store-invoice-payments/change-approvement', {
            id,
            isApproved,
          })
          await dispatch('search')
          return data
        },
        commit,
        [id, isApproved],
        { loadingPath: 'approvementLoading' },
      )
    },
    recalculate({ commit }, id) {
      return fetchWrapper(
        async (id) => {
          const { data } = await httpClient.get(`/store-invoice-payments/${id}/recalculate`)
          return data
        },
        commit,
        [id],
        { loadingPath: 'recalculationLoading' },
      )
    },
    createCreditInvoice({ commit }, id) {
      return fetchWrapper(
        async (id) => {
          const { data } = await httpClient.get(`/store-invoice-payments/${id}/create-credit-invoice`)
          return data
        },
        commit,
        [id],
        { loadingPath: 'isCreatingCreditInvoice' },
      )
    },
  },
}
